import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Card, CardSection, Flex, IconSvg } from '@/lib/v2/components';
import { SectionHeader } from '@/lib/v2/examples/SectionHeader';
import { CreateIcon } from '@/lib/v2/icons/outline';
import { CampaignsIcon } from '@/lib/v2/icons/solid';

import { CreateEditCampaigns } from '@/src/modules/CampaignsModule/components/CampaignsModal';
import { CampaignsTable } from '@/src/modules/CampaignsModule/components/CampaignsTable';

const CampaignsMain = () => {
  const { t } = useTranslation();
  const [openEditCategoryModal, setOpenEditCategoryModal] = useState<boolean>(false);

  const handleCreateCampaign = useCallback(() => {
    setOpenEditCategoryModal(!openEditCategoryModal);
  }, [openEditCategoryModal]);

  return (
    <>
      <Card>
        <CardSection noPadding>
          <Flex column>
            <SectionHeader
              actionsButtons={
                <Button
                  iconLeft={<IconSvg strokeColor="white" svgComponent={<CreateIcon />} />}
                  id="create-campaigns-button"
                  onClick={handleCreateCampaign}
                >
                  {t('CAMPAIGNS_MAIN.button')}
                </Button>
              }
              icon={<CampaignsIcon />}
              subtitle={t('noResultsFound')}
              title={t('CAMPAIGNS_MAIN.title')}
              titleDetail="(0)"
            />
            <Flex column withGap gapSize="medium">
              <CampaignsTable callToAction={[handleCreateCampaign]} />
            </Flex>
          </Flex>
        </CardSection>
      </Card>
      {openEditCategoryModal && (
        <CreateEditCampaigns
          show={openEditCategoryModal}
          onClose={() => setOpenEditCategoryModal(false)}
        />
      )}
    </>
  );
};

export default CampaignsMain;
